module.exports = __webpack_public_path__ + "static/media/food-2.e470ce78.jpg";